// @ts-check
import { api } from "../client.js";

/**
 * Endpoints da integração WhatsApp.
 *
 * Repare no que NÃO existe aqui: nenhuma função devolve o Access Token. A
 * tela mostra a máscara (`accessTokenMask`) e envia um valor novo quando o
 * usuário quer trocar — o token em si nunca trafega de volta.
 */
export const whatsappApi = {
  getConfig: () => api.get("/whatsapp/config"),

  /** @param {Record<string, string>} dados */
  saveConfig: (dados) => api.put("/whatsapp/config", dados),

  testConnection: () => api.post("/whatsapp/config/test"),

  /** @param {{ to: string, message: string, leadId?: string|null }} dados */
  sendMessage: (dados) => api.post("/whatsapp/messages", dados),

  conversations: () => api.get("/whatsapp/conversations"),

  /** @param {{ eventType?: string, limit?: number }} [filtros] */
  logs: (filtros) => api.get("/whatsapp/logs", filtros),
};
